export default function paramsDistrict(id) {
  if (id === 4) return 'skane'

  if (id === 5) return 'otraf'

  if (id === 17) return 'tib'

  if (id === 19) return 'x-trafik'

  if (id === 21) return 'norrtag'

  if (id === 22) return 'oresundstag'
}
